/* eslint-disable import/no-named-as-default */
import Input from './Input';

export default Input;
